<template>
  <div class="laddercontrol">
    <div class="header">
      <div class="title">多种乘梯方式 生活更便捷</div>
      <div class="border"></div>
    </div>

    <div class="body">
      <div class="list">
        <div class="item" v-for="item in laddercontrol" :key="item.id">
          <img :src="item.logo" alt="" />
          <div>{{ item.title }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive } from "vue";

import laddercontrol1 from "../../../../assets/programme/laddercontrol1.png";
import laddercontrol2 from "../../../../assets/programme/laddercontrol2.png";
import laddercontrol3 from "../../../../assets/programme/laddercontrol3.png";
import laddercontrol4 from "../../../../assets/programme/laddercontrol4.png";
import laddercontrol5 from "../../../../assets/programme/laddercontrol5.png";
import laddercontrol6 from "../../../../assets/programme/laddercontrol6.png";

export default {
  setup() {
    return reactive({
      laddercontrol: [
        {
          id: 1,
          title: "刷卡乘梯",
          logo: laddercontrol1,
        },
        {
          id: 2,
          title: "人脸识别乘梯",
          logo: laddercontrol2,
        },
        {
          id: 3,
          title: "一键分享访客乘梯",
          logo: laddercontrol3,
        },
        {
          id: 4,
          title: "预约乘梯",
          logo: laddercontrol4,
        },
        {
          id: 5,
          title: "自动呼梯",
          logo: laddercontrol5,
        },
        {
          id: 6,
          title: "欠费停梯",
          logo: laddercontrol6,
        },
      ],
    });
  },
};
</script>

<style scoped>
.laddercontrol {
  width: 1180px;
  margin: 80px auto 0;
}

.header .title {
  font-size: 30px;
  text-align: center;
}

.header .border {
  width: 40px;
  height: 5px;
  background: #248efb;
  margin: 20px auto 0;
}

.body {
  margin-top: 40px;
}

.body .list {
  display: flex;
  justify-content: space-between;
}

.body .list .item {
  position: relative;
  overflow: hidden;
}
.body .list .item:hover img {
  animation: experienceHover 1s;
}
@keyframes experienceHover {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(1.2);
  }
}
.body .list .item img {
  width: 180px;
}

.body .list .item div {
  width: 100%;
  text-align: center;
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  font-size: 16px;
  color: #ffffff;
  background: rgba(255, 255, 255, 0.2);
  padding: 16px 0;
  backdrop-filter: blur(20px);
}
</style>
